import Image from "../Article/Image";

export default function ImageGrid({ images, onImageClick }) {
  return (
    <div className="grid grid-cols-2 gap-4 my-4">
      {images.map((data) => {
        const image = data.image;

        // console.log(image);
        if (!image || data.disabled) return null;

        return (
          <div
            key={image.id}
            onClick={() => onImageClick(image.id)}
            className="cursor-pointer"
          >
            <Image
              src={image.url}
              caption={image.caption}
              alt={image.alt}
              preset="article4x3"
            />
          </div>
        );
      })}
    </div>
  );
}
